import { Box, Grid } from "@mui/material";
import React from "react";
interface IProps {
    actions: React.ReactNode[];
}

export const MprcFormBarHeader: React.FC<IProps> = ({ actions }) => {

    return (
        <Box
            id="mprcFormBarHeader"
            sx={
                (theme) =>
                ({
                    backgroundColor: theme.palette.paper.dark,
                    borderBottom: "solid 1px",
                    borderBottomColor: theme.extended.workArea.navigationBar.separatorColor,
                    borderTop: "solid 1px",
                    borderTopColor: theme.extended.workArea.navigationBar.separatorColor,
                    paddingTop: theme.spacing(.5),
                    paddingBottom: theme.spacing(.5),
                    paddingRight: theme.spacing(2),
                    paddingLeft: theme.spacing(1),
                    marginLeft: theme.spacing(-2),
                    marginRight: theme.spacing(-2),
                    marginTop: theme.spacing(-2),
                })
            }>
            <Grid
                container
                justifyContent={actions.length === 1 ? "start" : "space-between"}
                alignItems="center"
                flexWrap="nowrap"
                minHeight={48}
                spacing={1}
            >
                {
                    actions.map((b, index) => {
                        return (
                            <Grid
                                key={index}
                                overflow={index == 1 ? "hidden" : undefined}
                            >
                                {b}
                            </Grid>
                        );
                    })
                }
            </Grid>
        </Box >
    );
};
